import { Outlet } from '@tanstack/react-router';

export function HotelListLayout() {
  return (
    <div className="h-full flex flex-col">
      <Outlet />
    </div>
  );
}
